import { render, staticRenderFns } from "./AddinfantTab.vue?vue&type=template&id=540d01d2&scoped=true"
import script from "./AddinfantTab.vue?vue&type=script&lang=js"
export * from "./AddinfantTab.vue?vue&type=script&lang=js"
import style0 from "./AddinfantTab.vue?vue&type=style&index=0&id=540d01d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d01d2",
  null
  
)

export default component.exports